<template lang="html">
  <div>
    <table-configuration-item
      v-model="selectedItemId"
      :clone-id="cloneId"
    />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :loading="!!isLoading"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      />
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import TableConfigurationItem from './TableConfigurationItem'

export default {
  name: 'TableConfigurationList',
  components: {TableConfigurationItem},
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Table Configuration',
      types: 'Table Configurations',
      apiRecordCommand: 'diningTableConfiguration'
    }
  },
  computed: {
    headers () {
      let result = [
        this.headerText('Configuration Name', 'name', true),
        this.headerText('Location Name', 'locationName', true),
        this.headerText('Comments', 'notes', true),
      ]
      if (this.$ftCS.DINING_ENABLE_FLOOR_PLAN) {
        result.push(this.headerSwitch('Using Floor Plan', 'useFloorPlan'))
      }
      result.push(
        this.headerSwitch('Meal Periods', 'allowDining'),
        this.headerSwitch('Events', 'allowEvent'),
        this.headerSwitch('Auto Assignable', 'autoAssignable'),
        this.headerInvertedSwitch('Active', 'disabled')
      )
      return result
    }
  },
  methods: {
    listCommandFilter (command) {
      return this.addCommandParamArray(command, 'include_fields', ['locationName', 'autoAssignable'])
    }
  }
}
</script>
